// Battle animation speed preference (GH-53): controls AI turn playback pacing
// and optimistic player-move animation. Persisted so it survives reloads.
export type BattleSpeed = '1x' | '2x' | 'instant';

const STORAGE_KEY = 'battleAnimationSpeed';
const SPEEDS: BattleSpeed[] = ['1x', '2x', 'instant'];

export const getBattleSpeed = (): BattleSpeed => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return (SPEEDS as string[]).includes(stored || '') ? (stored as BattleSpeed) : '1x';
  } catch {
    return '1x';
  }
};

export const setBattleSpeed = (speed: BattleSpeed): void => {
  try {
    localStorage.setItem(STORAGE_KEY, speed);
  } catch {
    // localStorage unavailable (private browsing etc) - speed just won't persist
  }
};

export const nextBattleSpeed = (current: BattleSpeed): BattleSpeed =>
  SPEEDS[(SPEEDS.indexOf(current) + 1) % SPEEDS.length];

export const battleSpeedDivisor = (speed: BattleSpeed): number => (speed === '2x' ? 2 : 1);
